module.exports = __webpack_public_path__ + "img/banner03_info_life.a11693b8.svg";